// ⚠️ AUTO-GENERATED: This file is managed by generate-icon-map.js
// You may override icons by editing manually, but keys will sync with translation-keys.js
// New keys will default to FaCircle unless specified here.
import { withDefaultSize } from "./presetWrapper";
import { wrapSvgIcon } from "./wrapSvgIcon.jsx";
import { svgDefs } from "./svg-definitions"; // SVG definitions for RAD icons
import { FaLanguage, FaFlag, FaList, FaPalette, FaQuestionCircle, FaExternalLinkAlt, FaPrint, FaSave, FaTrash, FaEdit, FaPlus, FaMinus, FaRedo, FaUndo, FaUpload, FaDownload, FaCircle, FaFolderOpen, FaTimes, FaEraser, FaCompress, FaExpand, FaProjectDiagram } from "react-icons/fa";
import { FaMinimize, FaMaximize } from "react-icons/fa6";
import { MdSettings, MdTitle, MdHelp, MdModelTraining, MdOutlineLanguage, MdTranslate, MdOutlineCategory, MdOutlineDescription, MdRestartAlt, MdWorkspacesOutline, MdDescription, MdCategory, MdOutlineSaveAlt, MdOutlineHexagon, MdZoomInMap, MdZoomOutMap, MdOutlineHome } from "react-icons/md";
import { AiOutlineExpand, AiOutlineTranslation } from "react-icons/ai";

export const ICON_COMPONENTS = {
  category_labels: MdOutlineCategory,
  language_handling: MdOutlineLanguage,
  app: MdOutlineCategory,
  general: MdOutlineCategory,
  actions: MdOutlineCategory,
  riva: MdOutlineCategory,
  bpa: MdOutlineCategory,
  RAD: FaCircle,
  model: MdModelTraining,
  labels: FaCircle,
  language: MdOutlineLanguage,
  select_language: FaFlag,
  lang_curated: MdTranslate,
  lang_standard: FaLanguage,
  lang_custom: FaList,
  lang_fictional: FaQuestionCircle,
  model_name: FaCircle,
  model_name_note: FaCircle,
  model_purpose: MdOutlineDescription,
  purpose_note: FaCircle,
  model_description: MdOutlineDescription,
  model_viewpoint: FaCircle,
  model_changed: FaCircle,
  app_title: MdTitle,
  home: MdOutlineHome,
  architecture: MdOutlineHome,
  theme: FaPalette,
  settings: MdSettings,
  help: MdHelp,
  translation_editor: FaEdit,
  translation_notice: AiOutlineTranslation,
  examples: FaCircle,
  editorprefs: FaCircle,
  custom_color: FaCircle,
  role: withDefaultSize(wrapSvgIcon(svgDefs.role), 20, 30),
  thread: withDefaultSize(wrapSvgIcon(svgDefs.thread), 16, 24),
  state: wrapSvgIcon(svgDefs.state),
  interaction: wrapSvgIcon(svgDefs.interaction),
  action: wrapSvgIcon(svgDefs.action),
  trigger: wrapSvgIcon(svgDefs.trigger),
  startrole: wrapSvgIcon(svgDefs.start_role),
  caserefine: withDefaultSize(wrapSvgIcon(svgDefs.case_refinement), 40, 30),
  partrefine: withDefaultSize(wrapSvgIcon(svgDefs.part_refinement), 40, 30),
  partrepeat: withDefaultSize(wrapSvgIcon(svgDefs.part_repeat), 40, 30),
  spring: wrapSvgIcon(svgDefs.spring),
  connection: withDefaultSize(wrapSvgIcon(svgDefs.connection), 30, 20),
  initiator: wrapSvgIcon(svgDefs.initiator),
  arch: FaCircle,
  ebes: FaFolderOpen,
  gen: MdOutlineSaveAlt,
  uow: MdOutlineHexagon,
  uow_note: FaCircle,
  first_cut: FaCircle,
  second_cut: FaCircle,
  project: FaProjectDiagram,
  editor: FaEdit,
  name: FaCircle,
  description: FaCircle,
  type: FaCircle,
  status: FaList,
  purpose: FaCircle,
  version: FaCircle,
  date_created: FaCircle,
  date_modified: FaCircle,
  open: FaFolderOpen,
  close: FaTimes,
  edit: FaEdit,
  new: FaCircle,
  save: FaSave,
  load: FaDownload,
  cancel: FaTimes,
  clear: FaEraser,
  delete: FaTrash,
  remove: FaMinus,
  add: FaPlus,
  undo: FaUndo,
  redo: FaRedo,
  undo_all: FaCircle,
  redo_all: FaCircle,
  clear_history: FaCircle,
  select: FaCircle,
  export: FaDownload,
  import: FaUpload,
  reset: MdRestartAlt,
  zoom_in: MdZoomInMap,
  zoom_out: MdZoomOutMap,
  zoom_reset: FaCompress,
  zoom_max: FaMaximize,
  zoom_min: FaMinimize,
  zoom_to_fit: AiOutlineExpand,
  show_print_modal: FaExternalLinkAlt,
  show_fullscreen: FaExpand,
  exit_fullscreen: FaCompress,
  print: FaPrint,
};

export const DEFAULT_ICON = FaCircle;
